import merge from 'lodash/merge'

import { type TemplateData } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import { CTAButtonBlockModule } from '../blocks/CTAButton'
import { TextBlockModule } from '../blocks/TextSection'
import { type EmailSectionCreate, type CampaignResourceCreate } from '../types'

const i18n = i18nPlugin.global

export const blankTemplate = async (
  brandId: string,
  locationId: string | null = null
): Promise<TemplateData<CampaignResourceCreate, EmailSectionCreate>> => ({
  blocks: [
    merge(
      TextBlockModule.createData({
        brandId,
        type: 'heading',
      }),
      {
        data: { text: i18n.t('email-builder.defaults.blank.heading') },
      }
    ),
    merge(
      TextBlockModule.createData({
        brandId,
        type: 'paragraph',
      }),
      {
        data: { text: i18n.t('email-builder.defaults.blank.paragraph') },
      }
    ),
    merge(CTAButtonBlockModule.createData({ brandId, type: 'cta' })),
  ],
  resource: {
    brandId,
    locationId,
    name: i18n.t('email-builder.defaults.blank.subject'),
    sections: [],
    subject: i18n.t('email-builder.defaults.blank.subject'),
  },
})
